export const tramites_item = [
    {
        "tramites_item_nombre" : "Licitaciones Públicas",
        "tramites_item_url" : "/Licitaciones",
        "tramites_item_descripcion":"Consultar la publicación de las bases de las convocatorias para participación en procesos de Licitación, junta de aclaraciones, presentación y apertura de proposiciones, y acto público en el que se da a conocer el fallo para la adquisición de bienes y/o contratación de servicios.",
        "icono": "Licitaciones.png"
    },
    
   
    {
        "tramites_item_nombre" : "Publicación de las bases para la enajenación de bienes muebles",
        "tramites_item_url" : "/Enajenacion",
        "tramites_item_descripcion":"Consultar la publicación de las bases para participación en procesos de venta de bienes muebles y vehículos propiedad del Poder Ejecutivo que han dejado de ser funcionales.",
        "icono": "Enajenacion.png"
    },
    {
        "tramites_item_nombre" : "Vinculación al Servicio Social y las Prácticas Profesionales",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/1690",
        "tramites_item_descripcion":"Vincular de manera directa a los estudiantes de las escuelas de nivel Bachillerato y Licenciatura que esten interesados en realizar el servicio social o práticas profesionales dentro del Poder Ejecutivo del Estado de Hidalgo, con la finalidad de que pongan en práctica los conocimientos aprendidos en el aula y adquieran habilidades profesionales para su futuro laboral.",
        "icono": "Servicio Social.png"
    },
    {
        "tramites_item_nombre" : "Visita al Museo de documentos históricos",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/1691",
        "tramites_item_descripcion":"Se ofrece a los visitantes la oportunidad de realizar recorridos por el museo de documentos históricos, donde podrán conocer la historia del Estado de Hidalgo, con el objetivo de fortalecer nuestra identidad como mexicanos.",
        "icono": "Visita a museo.png"
    },
    {
        "tramites_item_nombre" : "Prestámo de documentos históricos",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/1693",
        "tramites_item_descripcion":"Facilita la consulta de documentos históricos, como libros, revistas, periódicos, planos y croquis, que forman parte del Archivo Histórico del Poder Ejecutivo del Estado de Hidalgo.",
        "icono": "Prestamo documentos.png"
    },
    {
        "tramites_item_nombre" : "Certificación de copias de documentos históricos",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/7663",
        "tramites_item_descripcion":"El Archivo Histórico del Estado de Hidalgo ofrece la certificación de copias de los documentos que resguarda. Este servicio esta destinado a apoyar a la ciudadanía en diversas actividades, como investigaciones históricas o académicas, procesos legales, proyectos culturales o artísticos, y la preservación de la memoria familiar, entre otros.",
        "icono": "Certificacion doc.png"
    },
    {
        "tramites_item_nombre" : "Pago de Arrendamiento",
        "tramites_item_url" : "https://ruts.hidalgo.gob.mx/ver/1694",
        "tramites_item_descripcion":"Proporcionar a los arrendatarios los formatos F7 para el pago de las mensualidades por concepto de arrendamiento de bienes inmuebles, propiedad de Gobierno del Estado.",
        "icono": "Arrendamientos.png"
    },
]

